import {INVALID_INVOICE_NUMBER_ERROR} from 'extensions/rma/data/constants';
import {RMAController} from 'extensions/rma/data/rma-controller';
import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement, nothing} from 'lit';
import stylesheet from './x-rma-invoice-lookup-form.scss?as=stylesheet';

export class RMAInvoiceLookupForm extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			controller: {
				state: true,
				type: Object
			},
			errorMessage: {
				type: String
			},
			loading: {
				state: true,
				type: Boolean
			},
			valid: {
				state: true,
				type: Boolean
			}
		};
	}

	get invoice () {
		return this.renderRoot.querySelector('input')?.value;
	}

	get form () {
		return this.renderRoot.querySelector('form');
	}

	constructor () {
		super();

		/**
		 * @type {RMAController}
		 */
		this.controller = new RMAController();

		/**
		 * @type {string}
		 */
		this.errorMessage = '';

		/**
		 * @type {boolean}
		 */
		this.loading = false;

		/**
		 * @type {boolean}
		 */
		this.valid = false;
	}

	async validateInvoice () {
		this.loading = true;
		this.errorMessage = '';

		const [, errorMessage] = await this.controller.getInvoice(this.invoice);

		this.loading = false;
		this.valid = !errorMessage;

		if (this.valid) {
			this.form?.submit();
		}
		else {
			this.errorMessage = INVALID_INVOICE_NUMBER_ERROR;
		}
	}

	handleSubmit (e) {
		if (this.valid === false) {
			e.preventDefault();

			this.validateInvoice();

			return false;
		}

		return true;
	}

	render () {
		return html`
			<form class="group" action="${window.mivaJS.RMA_Url}" @submit="${this.handleSubmit}">
				<input class="input" type="text" required placeholder="Invoice #" name="Invoice" inputmode="numeric" />
				<button class="submit-button" type="submit" ?disabled="${this.loading}">${this.loading ? `Loading...` : `Find`}</button>
			</form>
			${this.errorMessage ? html`<div class="message x-messages x-messages--error">${this.errorMessage}</div>` : nothing}
		`;
	}
};

defineCustomElement('x-rma-invoice-lookup-form', RMAInvoiceLookupForm);
